import { get, post } from '@axios';
import { showLoader, hideLoader } from 'actions/loader';
import { requests } from 'shared/requests';

const getGroups = () => async (dispatch) => {
  dispatch(showLoader());
  try {
    let groups = await get({ url: requests.getAllGroups });
    dispatch(hideLoader());
    return groups;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const createGroup = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.createGroup, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const getGroup = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.getThisGroupData, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const updateGroup = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.updateGroup, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const updateGroupProducts = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.updateGroupProducts, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const syncGroupProducts = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.syncGroupProducts, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const updateLabelPrint = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.updateLabelPrint, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

const updatePaymentSkip = (data) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const response = await post({ url: requests.updatePaymentSkip, data });
    dispatch(hideLoader());
    return response;
  } catch (error) {
    dispatch(hideLoader());
    return { error: true, message: error.message };
  }
};

export {
  getGroups,
  createGroup,
  getGroup,
  updateGroup,
  updateGroupProducts,
  syncGroupProducts,
  updateLabelPrint,
  updatePaymentSkip,
};
